import { useEffect, useState } from "react";
import MaterialTable, { MTableToolbar } from "material-table";
import {
  Box,
  Typography,
} from "@mui/material";
import SelectableMultiSelect from "../../../../Base/views/SelectableMultiSelect";

const PayrunApprovedWorkBased = ({dailyWageReportCompletedData, isLoading,filters,
  handleFilterChange,
  handleWorkLoacation,
  worklocationData}) => {

  const [dailyWageReportData, setDailyWageReportData] = useState([]);

  useEffect(() => {
    setDailyWageReportData(dailyWageReportCompletedData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dailyWageReportCompletedData]);
  

  const tableTitle = (
    <Box>
      <Typography variant="h6" fontWeight={600}>
        Employee
      </Typography>
      <Typography variant="body2" fontWeight={500}>
        Action Completed
      </Typography>
    </Box>
  );
  return (
    <Box mt={4} mb={1}>
      <Box>
        <MaterialTable
          isLoading={isLoading}
          columns={[
            {
              title: "Employee No",
              headerStyle: {
                width: "12%",
                padding: "10px 0px 5px 10px",
                textAlign: "start",
              },
              cellStyle: {
                width: "12%",
                textAlign: "start",
                padding: "10px 0px 5px 13px",
              },
              field: "employee_no",
            },
            {
              title: "Employee Name",
              headerStyle: {
                width: "15%",
                padding: "10px 0px 5x 5px",
                textAlign: "start",
              },
              cellStyle: {
                width: "15%",
                textAlign: "start",
                padding: "0px 0px 0px 5px",
              },
              field: "employee_name",
            },
            {
                title: "Work Location",
                field: "work_location_name",
                headerStyle: {
                  width: "12%",
                  padding: "0px 0px 0px 5px",
                  textAlign: "start",
                },
                cellStyle: {
                  width: "12%",
                  textAlign: "start",
                  padding: "10px 0px 5px 5px",
                },
                render: (rowData) => rowData?.work_location_name || "N/A"
            },
            {
              title: "DOJ",
              field: "doj",
              align: "center",
              headerStyle: {
                width: "9%",
                padding: "0px 0px 0px 5px",
                textAlign: "start",
              },
              cellStyle: {
                width: "9%",
                textAlign: "start",
                padding: "0px 0px 0px 5px",
              },
            },
            {
              title: "Days In Month",
              field: "days_in_a_month",
              headerStyle: {
                width: "12%",
                padding: "0px 0px 0px 5px",
                textAlign: "start",
              },
              cellStyle: {
                width: "12%",
                textAlign: "start",
                padding: "0px 0px 0px 3%",
              },
            },
            {
              title: "Actual Working Days",
              field: "actual_working_days",
              headerStyle: {
                width: "12%",
                padding: "0px 0px 0px 5px",
                textAlign: "start",
              },
              cellStyle: {
                width: "12%",
                textAlign: "start",
                padding: "0px 0px 0px 3%",
              },
            },
            {
              title: "Total Earnings",
              field: "total_earnings",
              headerStyle: {
                width: "12%",
                padding: "0px 0px 0px 5px",
                textAlign: "start",
              },
              cellStyle: {
                width: "12%",
                textAlign: "start",
                padding: "0px 0px 0px 2%",
              },
              render: (rowData) => rowData?.total_earnings || 0,
            },
            {
              title: "Total Deductions",
              field: "total_deductions",
              headerStyle: {
                width: "14%",
                padding: "0px 0px 0px 5px",
                textAlign: "start",
              },
              cellStyle: {
                width: "14%",
                textAlign: "start",
                padding: "0px 0px 0px 2%",
              },
              render: (rowData) => rowData?.total_deductions || 0,
            },
            {
              title: "Net Salary",
              field: "net_salary",
              headerStyle: {
                width: "10%",
                padding: "0px 0px 0px 5px",
                textAlign: "start",
              },
              cellStyle: {
                width: "10%",
                textAlign: "start",
                padding: "0px 0px 0px 2%",
              },
              render: (rowData) => rowData?.net_salary || 0,
            },
          ]}
          data={dailyWageReportData || []}
          options={{
            maxBodyHeight: 320,
            minBodyHeight: 320,
            maxWidth: "80vh",
            rowStyle: { fontSize: "13px" },
            headerStyle: { padding: "10px 0px 10px 0px", fontWeight: "bold" },
            cellStyle: { height: "35px" },
            sorting: true,
            search: true,
            searchFieldAlignment: "right",
            searchAutoFocus: false,
            filtering: false,
            paging: true,
            pageSizeOptions: [25, 50],
            pageSize: 25,
            selection: false,
            actionsColumnIndex: -1,
            showSelectAllCheckbox: true,
            showTextRowsSelected: true,
            grouping: false,
            columnsButton: false,
            showTitle: true,
          }}
          components={{
            Toolbar: (props) => (
              <Box sx={{ width: "full", display: "flex", flexDirection: { xs: "column", sm: "row" }, flexGrow: 1 }}>
                  <Box
                      sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      backgroundColor: "#f3edfd",
                      padding: "0px 0px 0px 20px",
                      flexGrow: 1,
                      minHeight: "48px !important",
                      }}
                  >
                  <Box>
                      <Typography variant='h6'>
                          {tableTitle}
                      </Typography>
                  </Box>
                  <Box sx={{width: "210px", display: "flex", alignItems: "center", pt: 0.5}}>
                      <SelectableMultiSelect
                          multiple
                          label="Work Location"
                          placeholder="Select Location"
                          value={filters?.ats_work_location_id}
                          loading={handleWorkLoacation}
                          fieldLabel="work_location_name"
                          name="ats_work_location_id"
                          size="small"
                          onChangeEvent={handleFilterChange}
                          data={worklocationData}
                          menuHeight={150} // optional
                      />
                  </Box> 
                  </Box>
                  <Box
                      sx={{
                          "& .MuiToolbar-root": {
                          padding: "14px 16px !important",
                          margin: "auto !important",
                          minHeight: "48px !important",
                          },
                          "& .MuiFormControl-root": {
                          margin: "0 !important",
                          },
                          "& .MuiInputBase-root": {
                          marginLeft: "-40px !important",
                          }
                      }}
                      >
                          <MTableToolbar {...props} />
                      </Box>
                  </Box>
          ),
          }}
          title={""}
        />
      </Box>

      
    </Box>
  );
};

export default PayrunApprovedWorkBased;
